import { deepClone } from './objects';

import { USER_PREFERENCES_COMPARISON_SETTINGS } from '@/redux/modules/user-preferences';
import { PERMISSIONS, userHasPermission } from './permissions';
import User from '@/types/user';
import PERIOD_END_DATA_OPTIONS from '@/types/period-end-data-options';

export const filteredPerformanceAndRiskDataOptions = (user: User, includeAuto: boolean, useMonthlyRebalancing?: boolean) => {
  const items = deepClone(USER_PREFERENCES_COMPARISON_SETTINGS.PERFORMANCE_AND_RISK_DATA);

  if (useMonthlyRebalancing) {
    const option = items.findIndex(item => item.value === PERIOD_END_DATA_OPTIONS.NONE);
    Object.assign(items[option], { hidden: true });
  }

  if (!userHasPermission(user, PERMISSIONS.PREVIOUS_MONTH_END_DATA)) {
    const option = items.findIndex(item => item.value === PERIOD_END_DATA_OPTIONS.PREVIOUS_MONTH_END);
    Object.assign(items[option], { hidden: true });
  }

  if (!userHasPermission(user, PERMISSIONS.QUARTER_END_DATA)) {
    const option = items.findIndex(item => item.value === PERIOD_END_DATA_OPTIONS.RECENT_QUARTER_END);
    Object.assign(items[option], { hidden: true });
  }

  if (!userHasPermission(user, PERMISSIONS.PREVIOUS_QUARTER_END_DATA)) {
    const option = items.findIndex(item => item.value === PERIOD_END_DATA_OPTIONS.PREVIOUS_QUARTER_END);
    Object.assign(items[option], { hidden: true });
  }

  if (!includeAuto || user.preferences?.autoPerformanceAndRiskData == null) {
    const option = items.findIndex(item => item.value === PERIOD_END_DATA_OPTIONS.AUTO);
    Object.assign(items[option], { hidden: true });
  }

  return items.filter(i => !i.hidden);
};
